import { render, staticRenderFns } from "./FeedbackersUpdate.vue?vue&type=template&id=2b384686"
import script from "./FeedbackersUpdate.vue?vue&type=script&lang=js"
export * from "./FeedbackersUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports